/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 18:32:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 12:50:41
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DotsMenuDrop/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { EllipsisOutlined } from '@ant-design/icons';

import { Menu, MenuItem, DropDown } from 'src/components/Antd';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const DotsMenuDrop = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const defaultModalConfig = {
    modalOnOk: (e: React.MouseEvent) => {
      return;
    },
    modalOkText: getI18n('general.delete'),
    modalOnCancel: (e: React.MouseEvent) => {
      return;
    },
    modalOnCancelText: getI18n('general.cancel'),
    modalTitle: getI18n('general.deleteModule'),
    modalContent: getI18n('general.deleteModuleContent'),
  };
  const { options = [], iconClassName, disabled } = props;
  const [dropVisible, setDropVisible] = React.useState(false);
  const [warningVisible, setWarningVisible] = React.useState(false);

  const [modalConfig, setModalConfig] = React.useState({
    ...defaultModalConfig,
  });
  // React.useEffect(() => {
  //   if (!warningVisible) {
  //     setModalConfig({ ...defaultModalConfig });
  //   }
  // }, [warningVisible]);
  const {
    modalOnOk,
    modalOkText,
    modalOnCancel,
    modalOnCancelText,
    modalTitle,
    modalContent,
  } = modalConfig;
  const renderMenu = () => {
    return (
      <div className='override'>
        <Menu selectedKeys={[]}>
          {options.map((i) => {
            const {
              onClick,
              key,
              body,
              displayWarningModal,
              modalOnOk,
              modalOkText,
              modalOnCancel,
              modalCancelText,
              modalTitle,
              modalContent,
              isDangerous,
            } = i;

            return (
              <MenuItem
                key={key}
                onClick={({ item, key, keyPath, domEvent }) => {
                  if (domEvent) domEvent.stopPropagation();
                  setDropVisible(false);
                  if (displayWarningModal) {
                    setModalConfig({
                      modalOnOk: (e) => {
                        if (modalOnOk) modalOnOk(e);
                        setWarningVisible(false);
                        return;
                      },
                      modalOkText: modalOkText,
                      modalOnCancel: (e) => {
                        if (modalOnCancel) modalOnCancel(e);
                        setWarningVisible(false);
                        return;
                      },
                      modalOnCancelText: modalCancelText,
                      modalTitle: modalTitle,
                      modalContent: modalContent,
                    });
                    setWarningVisible(true);
                  } else {
                    if (onClick) onClick({ item, key, keyPath, domEvent });
                  }
                }}>
                <div
                  className={!isDangerous ? css.btnText : css.dangerousText}
                  onClick={(e) => {
                    setDropVisible(false);
                  }}>
                  {body}
                </div>
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    );
  };
  return (
    <WarningPopReminder
      visibilityOption={{
        controlledByParent: true,
        controlledVisible: warningVisible,
        setControlledVisible: setWarningVisible,
      }}
      title={modalTitle}
      content={modalContent}
      onCancelText={modalOnCancelText}
      onCancel={modalOnCancel}
      onOkText={modalOkText}
      onOk={modalOnOk}>
      <DropDown
        disabled={disabled}
        overlay={renderMenu()}
        trigger={['click']}
        visible={dropVisible}
        onVisibleChange={setDropVisible}>
        <EllipsisOutlined
          rev
          className={`${css.icon} ${iconClassName || ''} ${
            disabled ? css.disabled : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      </DropDown>
    </WarningPopReminder>
  );
};
export default DotsMenuDrop;
